import React from "react";
import radianceLogo from "../../Assets/new_ra_logo.jpg";
import classes from "./Logo.module.css";

const Logo = () => {
  return (
    <div className={classes.logoWrapper}>
      <img className={classes.logo} src={radianceLogo} alt="Radiance Logo" />
    </div>
  );
};

export default Logo;
